import { IoSearchOutline } from "react-icons/io5";

export const SearchIcon = ({ customClasses = "w-6 h-6" }) => {
  return (
    <section>
      <IoSearchOutline className={customClasses} />
    </section>
  );
};
